// extracted by mini-css-extract-plugin
module.exports = {"root":"mask_root__d9LGz","root_active":"mask_root_active__2rSU5","root_active_fullscreen":"mask_root_active_fullscreen__1Tltg"};